import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const EnergyNeeds = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/energy-needs/components/EnergyNeedsContent'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/energy-needs/components/EnergyNeedsHeader'
      )
  )
};

export default EnergyNeeds;
